'use client';

import * as React from 'react';
export const GridChartsIntegrationContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") GridChartsIntegrationContext.displayName = "GridChartsIntegrationContext";